import { config } from "./config";

export interface PublicTicketTierPrice {
  price?: number | null;
  absorb_fee?: boolean | null;
}

/**
 * The event is the source of truth for the buyer service fee. The configured
 * default is only for historical events where that field was never persisted.
 */
export function resolveEventFeePercent(platformFeePercent?: number | null): number {
  const parsed = Number(platformFeePercent);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : config.platformFeePercent;
}

export function calculateBuyerServiceFee(
  basePrice: number,
  platformFeePercent?: number | null,
  absorbFee?: boolean | null,
): number {
  if (absorbFee || basePrice <= 0) return 0;
  return Math.round(basePrice * resolveEventFeePercent(platformFeePercent)) / 100;
}

export function calculateTicketTotal(
  basePrice: number,
  platformFeePercent?: number | null,
  absorbFee?: boolean | null,
): number {
  return basePrice + calculateBuyerServiceFee(basePrice, platformFeePercent, absorbFee);
}

export function lowestTicketTotal(
  tiers: PublicTicketTierPrice[],
  platformFeePercent?: number | null,
): number {
  if (tiers.length === 0) return 0;
  return Math.min(
    ...tiers.map((tier) => calculateTicketTotal(Number(tier.price ?? 0), platformFeePercent, tier.absorb_fee)),
  );
}
